import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-page-size-selector',
  templateUrl: './page-size-selector.component.html',
  styleUrls: ['./page-size-selector.component.scss']
})
export class PageSizeSelectorComponent implements OnInit {

  @Input() sizePageSteps: number[];

  @Output() onChangeValue: EventEmitter<any> = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

  onChange(val) {
    console.log(val);
    this.onChangeValue.emit(val);
  }

}
